module.exports = __webpack_public_path__ + "img/sun.877bf01a.svg";